module.exports = {
  title: '平台子账号',
  route: {
    path: 'staff-manage',
    children: {
      path: 'platform-subaccount-list',
    },
  },
};
